export default __webpack_public_path__ + "static/emoji-blurred-alt-ff5a3dec3336c86ecc1a5a07f4549aaa.svg";